import { SxProps } from '@mui/system';

import { theme } from 'theme';

export const projectsList: SxProps = {
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  columnGap: '8px',
  rowGap: '16px',
};

export const divider: SxProps = {
  margin: '24px 0 8px',
  borderColor: theme.palette.grey['50'],
};
